// Mirrors backend src/config/constants.js

export const ROLES = {
  USER: "USER",
  ADMIN: "ADMIN",
  TECHNICIAN: "TECHNICIAN",
  WORKSHOP: "WORKSHOP",
  CHANNEL_PARTNER: "CHANNEL_PARTNER",
};

export const BOOKING_STATUS = {
  PENDING_PAYMENT: "PENDING_PAYMENT",
  BOOKED: "BOOKED",
  ASSIGNED: "ASSIGNED",
  IN_SERVICE: "IN_SERVICE",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

export const BOOKING_STATUS_LABELS = {
  PENDING_PAYMENT: "Pending Payment",
  BOOKED: "Booked",
  ASSIGNED: "Assigned",
  IN_SERVICE: "In Service",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

export const BOOKING_STATUS_COLORS = {
  PENDING_PAYMENT: "warning",
  BOOKED: "info",
  ASSIGNED: "info",
  IN_SERVICE: "primary",
  COMPLETED: "success",
  CANCELLED: "error",
};

export const BOOKING_SOURCE_LABELS = {
  customer_app: "App/Website",
  staff_panel: "Staff Panel",
  walk_in: "Walk-in",
  phone_call: "Phone Call",
  whatsapp: "WhatsApp",
  lead_conversion: "Lead",
};

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  REFUNDED: "REFUNDED",
};

export const FUEL_TYPES = ["PETROL", "DIESEL", "CNG", "ELECTRIC", "HYBRID", "LPG"];
export const TRANSMISSION_TYPES = ["MANUAL", "AUTOMATIC", "AMT", "CVT", "DCT"];
export const ADDRESS_LABELS = ["HOME", "WORK", "OTHER"];

export const COMPLAINT_CATEGORIES = [
  "BOOKING",
  "PAYMENT",
  "TECHNICIAN",
  "SERVICE_QUALITY",
  "APP_ISSUE",
  "OTHER",
];

export const COMPLAINT_STATUS = {
  OPEN: "OPEN",
  IN_PROGRESS: "IN_PROGRESS",
  RESOLVED: "RESOLVED",
  CLOSED: "CLOSED",
};

export const SUBSCRIPTION_STATUS = {
  PENDING_PAYMENT: "PENDING_PAYMENT",
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
};

export const VEHICLE_TYPES = ["HATCHBACK", "SEDAN", "SUV", "LUXURY"];

export const REFUND_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  PROCESSED: "PROCESSED",
  REJECTED: "REJECTED",
};

export const REFUND_DESTINATION = {
  WALLET: "WALLET",
  ORIGINAL: "ORIGINAL",
};

export const WARRANTY_CLAIM_TYPE = {
  SERVICE_WARRANTY: "SERVICE_WARRANTY",
  PART_WARRANTY: "PART_WARRANTY",
  PAID_RR: "PAID_RR",
};

export const WARRANTY_CLAIM_STATUS = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RESOLVED: "RESOLVED",
};

export const RR_STATUS = {
  INITIATED: "INITIATED",
  SUBMITTED: "SUBMITTED",
  ADMIN_APPROVED: "ADMIN_APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  COMPLETED: "COMPLETED",
};

export const RR_STATUS_LABELS = {
  INITIATED: "Initiated",
  SUBMITTED: "Pending Review",
  ADMIN_APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
  COMPLETED: "Completed",
};

export const RR_STATUS_COLORS = {
  INITIATED: "warning",
  SUBMITTED: "warning",
  ADMIN_APPROVED: "success",
  REJECTED: "error",
  CANCELLED: "neutral",
  COMPLETED: "info",
};

export const RR_TYPE = {
  WARRANTY: "warranty",
  PAID: "paid",
};

export const ESTIMATE_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

// Channel Partner commission model — single source of truth for every place
// that renders a label for these (dropdown, table display, helper text,
// reports, filters, badges). Add a new model here once, everywhere updates.
// `shareOwner` disambiguates the one real trap across these three models:
// the "Commission Value" number means the PLATFORM's cut for Percentage/Flat,
// but the PARTNER's cut for Profit Share — same field, opposite direction.
// Always render `shareOwnerLabel` next to the value input so this never has
// to be memorized.
export const COMMISSION_TYPE_OPTIONS = [
  {
    value: "PERCENTAGE",
    label: "Percentage (% of Invoice)",
    shortLabel: "Percentage",
    unit: "%",
    valueLabel: "Commission Percentage",
    helpText: null,
    shareOwner: "PLATFORM",
    shareOwnerLabel: "This is MechOnGo's share — the partner receives the rest",
  },
  {
    value: "FLAT",
    label: "Flat Amount (₹)",
    shortLabel: "Flat Amount",
    unit: "₹",
    valueLabel: "Commission Value",
    helpText: null,
    shareOwner: "PLATFORM",
    shareOwnerLabel: "This is MechOnGo's share — the partner receives the rest",
  },
  {
    value: "PROFIT_SHARING",
    label: "Profit Share (% of Net)",
    shortLabel: "Profit Share",
    unit: "%",
    valueLabel: "Profit Sharing Percentage",
    helpText:
      "Partner receives this percentage of the shareable amount (after Parts Cost and Gateway Fees).",
    shareOwner: "PARTNER",
    shareOwnerLabel: "This is the Partner's share — MechOnGo keeps the rest",
  },
];

export const COMMISSION_TYPE_MAP = Object.fromEntries(
  COMMISSION_TYPE_OPTIONS.map((o) => [o.value, o]),
);
